/* eslint-disable react/prop-types */
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {useState} from "react";
import Loading from "../../components/Loading";
import fixTableCellWidth from "../../functions/fixTableCellWidth";
import {useNavigate} from "react-router-dom";
import SoftBadge from "../../components/SoftBadge";
import {deleteRatingFactor} from "../../api/routes";
import {toast} from "react-toastify";
import ellipsis from "../../functions/ellipsis";

function createData(id, name, description, createdAt, operation) {
    return {
        id,
        name,
        description,
        createdAt,
        operation
    };
}

function Row(props) {
    const {row} = props;

    return (
        <React.Fragment>
            <TableRow sx={{'& > *': {borderBottom: 'unset'}}}>
                <TableCell className="tablecell" align="left" title={row.name}
                           style={fixTableCellWidth("210px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.description}
                           style={fixTableCellWidth("210px")}>{ellipsis(row.description,40)}</TableCell>
                <TableCell className="tablecell" align="left" title={new Date(row.createdAt).toLocaleString('fa-IR')}
                           style={fixTableCellWidth("150px")}>{new Date(row.createdAt).toLocaleString('fa-IR')}</TableCell>
                <TableCell className="tablecell" align="left"
                           style={fixTableCellWidth("200px")}>{row.operation}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function RatingFactorTable({data}) {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()

    const handleDeleteRatingFactor = (ratingFactorId) => {
        let answer = window.confirm("آیا از حذف اطمینان دارید؟");
        if (answer) {
            setLoading(true);
            deleteRatingFactor(ratingFactorId, (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    setLoading(false);
                    toast.success("Your request has been submitted");
                    window.location.reload()
                }
            })
        }
    }

    const rows = data.map(item => createData(item.id, item.name, item.description, item.created_at, <section
            style={{display: "flex", cursor: 'pointer'}}>
            <SoftBadge variant="contained"
                       onClick={() => navigate(`/new-rating-factor?method=update&ratingFactorId=${item.id}`)}
                       badgeContent="آپدیت"
                       color="secondary" size="xs"/>
            <SoftBadge variant="contained"
                       badgeContent="حذف"
                       onClick={() => handleDeleteRatingFactor(item.id)}
                       color="error" size="xs"/>
        </section>
    ))

    return (
        <>
            <Loading loading={loading}/>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <SoftBadge variant="contained"
                                   onClick={() => navigate("/new-rating-factor")}
                                   badgeContent="رای گیری جدید" color="success" size="xs"
                                   container
                                   style={{cursor: 'pointer', marginLeft: 5}}/>
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("210px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("210px")}>توضیحات</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("200px")}>عملیات ها</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{display: 'block'}}>
                        {rows.map((row) => (
                            <Row key={row.id} row={row}/>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </>
    );
}
